//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fileUploader from '../../views/common-components/file-uploader';
import arrayToTree from 'array-to-tree';
import SelectCouponModal from '../coupons/components/select-coupon-modal';

export default {
    name: 'activityEdit',
    components: {
        SelectCouponModal,
        fileUploader
    },
    data() {
        return {
            activity: {
                isContribute: false,
                isSignUp: false,
                activityContent: '',
                file: {associateType: 'ActivityLogo'},
                isSignUpLimit: true,
                isHouseholdNum: true,
                isLimit: true
            },
            loading: false,
            saving: false,
            activityId: 0,
            rules: {
                activityName: {required: true, message: '请输入活动名称', trigger: 'blur'},
                activityType: {required: true, type: 'number', message: '请选择活动类型', trigger: 'change'},
                introduction: {required: true, message: '请输入活动简介', trigger: 'blur'},
                address: {required: true, message: '请输入活动地点', trigger: 'blur'},
                householdNum: {required: true, type: 'number', message: '请输入每户限制人数', trigger: 'blur'}
            },
            indeterminate: true,
            checkAll: false,
            checkAllGroup: [],
            cityList: [],
            projectTree: [],
            cityRanges: [],
            showTreeModal: false,
            showSelectCouponModel: false
        };
    },
    methods: {

        getActivity() {
            this.loading = true;
            abp.ajax.get('/api/services/app/Activity/GetActivityById?id=' + this.activityId).then(res => {
                this.activity = JSON.parse(JSON.stringify(res.data.result));
                this.activity.file = {associateType: 'ActivityLogo'};

                this.cityRanges = this.activity.cityRanges;
                this.isEditRange = false;
                this.activity.file = {associateType: 'ActivityLogo'};

                if (this.activity.memberLevel != null && this.activity.memberLevel != '' && this.activity.memberLevel != undefined) {
                    this.checkAllGroup = this.activity.memberLevel.split(',');
                }

            }).finally(() => {
                this.loading = false;
            });
        },

        onSaveActivity() {
            var vm = this;
            // console.log(vm.activity)
            // console.log(vm.activity.timeSlot)
            // return;
            if (!vm.activity.startDateTime) {
                abp.message.error('活动开始时间不能为空！');
                return;
            }
            if (!vm.activity.endDateTime) {
                abp.message.error('活动结束时间不能为空！');
                return;
            }

            if (vm.activity.isSignUp && !vm.activity.signUpStartTime) {
                abp.message.error('报名开始时间不能为空！');
                return;
            }
            if (vm.activity.isSignUp && !vm.activity.signUpEndTime) {
                abp.message.error('报名结束时间不能为空！');
                return;
            }

            vm.activity.memberLevel = this.checkAllGroup.toString();
            vm.activity.isEditRange = this.isEditRange;
            if (this.isEditRange) {
                vm.activity.oldCityRanges = this.activity.cityRanges;
                vm.activity.cityRanges = vm.cityRanges;
            }
            // vm.activity.cityRanges = vm.cityRanges;
            // = [];
            // if (this.activity.cityRanges.length > 0 && vm.cityRanges.length != 0) {
            //     vm.activity.oldCityRanges = this.activity.cityRanges;
            // }

            this.$refs.activityForm.validate(async (val) => {
                if (val) {
                    this.saving = true;
                    console.log('activity:' + vm.activity);
                    console.log('val:' + val);

                    vm.$store.dispatch({
                        type: 'activity/saveActivity',
                        data: vm.activity
                    }).then(() => {

                        vm.$Notice.success({
                            duration: 3,
                            title: '保存成功'
                        });


                        vm.$router.push({
                            name: 'activityDetail',
                            params: {
                                id: vm.$store.state.activity.activityId
                            }
                        });

                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },

        handleCheckAll() {
            if (this.indeterminate) {
                this.checkAll = false;
            } else {
                this.checkAll = !this.checkAll;
            }
            this.indeterminate = false;

            if (this.checkAll) {
                this.checkAllGroup = ['1', '2', '3', '4'];
                // this.checkAllGroup = ['2', '3', '4'];
            } else {
                this.checkAllGroup = [];
            }
        },
        checkAllGroupChange(data) {
            if (data.length === 4) {
                this.indeterminate = false;
                this.checkAll = true;
            } else if (data.length > 0) {
                this.indeterminate = true;
                this.checkAll = false;
            } else {
                this.indeterminate = false;
                this.checkAll = false;
            }
        },
        getProjectStagesTree() {

            abp.ajax.get('/api/services/app/Project/GetProjectRoomStructureNameTree').then(res => {
                this.projectTree = [];
                this.projectTree = res.data.result.items;
                this.projectTree.forEach((city, index) => {
                    city.title = city.name;
                    city.children = city.projects;
                    city.type = 'city';
                    city.parentId = 0;
                    city.children.forEach(project => {
                        project.children = project.stages;
                        project.parentId = project.cityId;
                        project.type = 'project';
                        project.children.forEach(i => {
                            i.parentId = i.projectId;
                            i.type = 'fenqi';

                            i.children.forEach(rs => {
                                rs.type = 'RoomStructureName'
                                rs.parentId = i.key
                            })
                        });
                    });
                });

                this.projectTree = arrayToTree(this.projectTree, {
                    parentProperty: 'parentId',
                    customID: 'id'
                });
            }).finally(() => {
                // this.saving = false;
            });
        },
        onSelectTree() {
            const list = this.$refs.treeRef.getCheckedAndIndeterminateNodes();


            this.cityRanges = [];
            var select = list.filter(x => x.type === 'city');
            select.forEach(city => {
                this.cityRanges.push({
                    id: 0,
                    businessId: 0,
                    cityId: city.id,
                    businessType: 'Activity',
                    cityName: city.title,
                    isAllCity: city.checked
                });
            });

            for (var i = 0; i < this.cityRanges.length; i++) {
                this.cityRanges[i].projectRanges = [];
                if (this.cityRanges[i].isAllCity) {
                    continue
                }
                var s1 = list.filter(x => x.cityId === this.cityRanges[i].cityId && x.type === "project");
                console.log('project')
                console.log(s1)
                console.log('project')
                let sss = [];
                s1.forEach(project => {
                    sss.push({
                        id: 0,
                        cityRangeId: 0,
                        projectId: project.id,
                        projectName: project.title,
                        cityId: project.cityId,
                        isAllProject: project.checked
                    });
                });

                this.cityRanges[i].projectRanges = sss;

                for (var j = 0; j < this.cityRanges[i].projectRanges.length; j++) {
                    this.cityRanges[i].projectRanges[j].stagesRanges = [];
                    if (this.cityRanges[i].projectRanges[j].isAllProject) {
                        continue
                    }
                    var s2 = list.filter(x => x.projectId === this.cityRanges[i].projectRanges[j].projectId && x.type === 'fenqi');
                    console.log('fenqi')
                    console.log(s2)
                    console.log('fenqi')
                    var ssss = [];
                    s2.forEach(s => {
                        ssss.push({
                            id: 0,
                            projectRangeId: 0,
                            name: s.title,
                            projectId: s.projectId,
                            isAll: s.checked
                        });
                    });

                    this.cityRanges[i].projectRanges[j].stagesRanges = ssss;

                    for (var k = 0; k < this.cityRanges[i].projectRanges[j].stagesRanges.length; k++) {
                        var fq = this.cityRanges[i].projectRanges[j].stagesRanges[k];
                        if (fq.isAll) {
                            continue;
                        }
                        // let l = this.getRoomStructureNames(list, fq.projectId, fq.name);
                        let l= list.filter(x => x.projectId === fq.projectId && x.type === 'RoomStructureName' && x.parentId === fq.name);
                        this.cityRanges[i].projectRanges[j].stagesRanges[k].roomStructureRanges = []

                        l.forEach(s => {
                            this.cityRanges[i].projectRanges[j].stagesRanges[k].roomStructureRanges.push({
                                id: 0,
                                projectRangeId: 0,
                                name: s.title,
                                projectId: s.projectId,
                                isAll: false
                            });
                        });

                    }

                    // this.$set(this.cityRanges[i].projectRanges[j],'stagesRanges',ssss)
                }

            }
            console.log('------------')
            console.log(list);
            console.log(this.cityRanges);
            this.showTreeModal = false;
            this.isEditRange = true;
        },

        getRoomStructureNames(list, projectId, key) {
            let rss = list.filter(x => x.projectId === projectId && x.type === 'RoomStructureName' && x.parentId === key);
            return rss
        },

        showAddACoupon() {
            this.showSelectCouponModel = true;
        },
        showCouponSetting(c) {
            this.couponSetting = {};
            this.couponSetting = c;
            this.showCouponSettingModel = true;
        },
        addCoupon(data) {
            // console.log(data);
            this.activity.couponName = data.name;
            this.activity.couponId = data.id;
            this.activity.businessType = 'Activity';
            this.showSelectCouponModel = false;
        },
        cancelChoiceCoupon() {
            this.activity.couponName = '';
            this.activity.couponId = 0;
            console.log(this.signUpInfo.couponName);
        },
        clearSignUpType() {

        },
        startDateTimeChange(date) {
            this.activity.startDateTime = date;
        },
        endDateTimeChange(date) {
            this.activity.endDateTime = date;
        },
        signUpStartTimeChange(date) {
            this.activity.signUpStartTime = date;
        },
        signUpEndTimeChange(date) {
            this.activity.signUpEndTime = date;
        }
    },
    created() {
        this.getProjectStagesTree();
        this.activityId = parseInt(this.$route.params.id || 0);
        if (this.activityId > 0) {
            this.getActivity();
        }
    },
    watch: {}
};
